import { gql } from '@apollo/client';

export const GET_WRITTEN_PAGINATED = gql`
  query Analytics(
    $projectId: ID!,
    $questionId: ID!,
    $segmentId: ID,
    $testerIds: [ID!],
    $limit: Int,
    $offset: Int,
    $search: String,
  ) {
    analytics(
      projectId: $projectId,
      questionId: $questionId,
      segmentId: $segmentId,
      testerIds: $testerIds,
      limit: $limit,
      offset: $offset,
      search: $search,
    ) {
      surveysAnalyticsWritten(
        projectId: $projectId,
        questionId: $questionId,
        segmentId: $segmentId,
        testerIds: $testerIds,
        limit: $limit,
        offset: $offset,
        search: $search,
      ) {
        total
        data {
          firstName
          valueText
        }
      }
    }
  }
`;
